import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/ui/button';

import { ClinicalVisitPanel } from './ClinicalVisitPanel';

/**
 * Lets a doctor resume and close a not-yet-closed visit straight from the pending list —
 * no need to reopen the sale order / doctor-POS draft. `ClinicalVisitPanel` already reads
 * and writes everything through `clinical_visit_id`, so it drops in unmodified here.
 */
export function ClinicalVisitEditModal({
  visit_id,
  onClose,
}: {
  visit_id: string;
  onClose: () => void;
}): JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={onClose}
    >
      <div
        className="bg-background flex max-h-[90vh] w-full max-w-4xl flex-col overflow-hidden rounded-lg border shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b px-4 py-3">
          <h2 className="text-base font-semibold">{t('clinical.resume_visit_title')}</h2>
          <Button variant="ghost" size="sm" onClick={onClose} aria-label={t('common.cancel')}>
            <X className="h-4 w-4" />
          </Button>
        </div>
        <div className="overflow-y-auto p-4">
          <ClinicalVisitPanel visit_id={visit_id} />
        </div>
      </div>
    </div>
  );
}
